/* API_URL in webpack config file  */
export const API = API_URL; // eslint-disable-line no-undef

// ПОЛЯ ФИЛЬТРОВ

// ПОЛУЧИТЬ ТИПЫ ПЕРЕВОЗОК
export const GET_SERVICE_TYPES = `${API}/request/service_types`;

// ПОЛУЧИТЬ ТИПЫ ЗАЯВОК
export const GET_REQUEST_TYPES = `${API}/request/types`;

// ПОЛУЧИТЬ ВИДЫ ЗАЯВОК
export const GET_REQUEST_VIEWS = `${API}/request/views`;

// ПОЛУЧИТЬ СПОСОБЫ ОПЛАТЫ
export const GET_PAYMENT_METHODS = `${API}/finance/payment_methods`;

// ПОЛУЧИТЬ УРОВНИ ОБСЛУЖИВАНИЯ
export const GET_MAINTENANCE_LEVELS = `${API}/request/maintenance_levels`;

// ПОЛУЧИТЬ СТАТУСЫ
export const GET_STATUSES = `${API}/requests/counts_by_statuses`;

// ПОЛУЧИТЬ СТАТУСЫ
export const GET_ORDER_STATUSES = `${API}/order/statuses`;

// ПОЛУЧИТЬ РЕГИОНЫ
export const GET_REGIONS = `${API}/request/regions`;

// ПОЛУЧИТЬ ДНИ НЕДЕЛИ
export const GET_WEEK_DAYS = `${API}/request/day_of_week`;

// ПОЛУЧИТЬ ДНИ НЕДЕЛИ
export const GET_SUBJECTS = `${API}/authorization/subjects`;

// ПОЛУЧИТЬ РОЛИ
export const GET_ROLES = `${API}/authorization/roles`;

// ПОЛУЧИТЬ ВСЕ КАТЕГОРИИ ТС
export const GET_VEHICLE_CATEGORIES = `${API}/transport/vehicle_categories`;

// ПОЛУЧИТЬ ВСЕ ГРАЖДАНСТВА
export const GET_CITIZENSHIPS = `${API}/authorization/citizenships`;

// ПОЛУЧИТЬ ВСЕ ЯЗЫКИ
export const GET_FOREIGN_LANGUAGES = `${API}/authorization/foreign_languages`;

// ПОЛУЧИТЬ ВСЕ ДОКУМЕНТЫ УДОСТОВЕРЕНИЯ ЛИЧНОСТИ
export const GET_IDENTITY_DOCUMENTS = `${API}/document/identity_documents`;

// ПОЛУЧИТЬ ВСЕ СТАТУСЫ ПРОФИЛЯ
export const GET_PROFILE_STATUS = `${API}/authorization/profile_statuses`;

// Получить все Типы Документов
export const GET_DOCUMENTS_TYPES = `${API}/document/document_types`;

// Получить все Статусы Документа
export const GET_DOCUMENTS_STATUSES = `${API}/document/document_statuses`;

// Получить все Способы Заполнения Документа
export const GET_DOCUMENTS_FILL_TYPES = `${API}/document/fill_types`;

// ПОЛУЧИТЬ ВСЕ ДОПОЛНИТЕЛЬНЫЕ ВИДЫ УСЛУГ
export const GET_SERVICE_ADDITIONALS = `${API}/request/service_additionals`;

// ПОЛЯ СВЯЗАННЫЕ С ПРОФИЛЕМ
// ПОЛУЧИТЬ СПИСОК КОМПАНИЙ ЗАКАЗЧИКОВ
export const GET_CUSTOMER_COMPANIES = `${API}/authorization/companies/{company_id}/customers`;

// ПОЛНОТЕКСТОВЫЙ ПОИСК КОМПАНИЙ ЗАКАЗЧИКОВ
export const GET_CUSTOMER_COMPANIES_SEARCH = `${API}/authorization/company/search_clients/carriers_collaborated_with`;

// ДОБАВИТЬ ИНФОРМАЦИЮ ПО ПРОСМОТРУ СУЩНОСТИ ПО ID ПРОФИЛЯ
export const SET_VIEW_LOG = `${API}/utility/view_log/`;

// ОТПРАВИТЬ СООБЩЕНИЕ ИЗ ФОРМЫ ОБРАТНОЙ СВЯЗИ
export const SEND_MESSAGE_FEEDBACK = `${API}/utility/mail/feedback/send`;

// ПОЛУЧИТЬ ВСЕХ ИСПОЛНИТЕЛЕЙ
export const GET_PERFORMERS = `${API}/authorization/company/licensee/relations/`;

// ПОЛУЧИТЬ ВСЕ ШАБЛОНЫ МОНЕТИЗАЦИЙ
export const GET_MONETIZATION_TEMPLATES = `${API}/offer/monetization_templates`;

// ПОЛУЧИТЬ subject_id НА ОСНОВЕ subject_key
export const GET_SUBJECT_ID_BY_SUBJECT_KEY = `${API}/authorization/subject/key/`;

// СОЗДАТЬ ШАБЛОН МОНЕТИЗАЦИИ
export const CREATE_MONETIZATION_TEMPLATE = `${API}/offer/monetization_templates`;
